module.exports = __webpack_public_path__ + "static/media/LogoCPCertificazioni.4a6e0a25.png";